<template>
  <v-text-field readlonly persistent-hint outline
    :id="uuid"
    :label="label"
    :dark='dark'
    style="font-size:smaller"
    :value="textToCopy"
    :prepend-icon="prependIcon"
    append-icon="file_copy"
    @click:append="copyToClipboard"
    :hint="copyLinkText"
  ></v-text-field>
</template>
<script>
export default {
  name: 'CopyTextField',
  props: {
    textToCopy: { type: String, required: true },
    label: { type: String, required: false },
    hint: { type: String, required: false },
    dark: { type: Boolean, default: false },
    prependIcon: { type: String, required: false },
    copiedToClipbaordText: { type: String, default: 'Copied to clipboard' }
  },
  data () {
    return {
      copyLinkText: ''
    }
  },
  mounted () {
    this.copyLinkText = this.hint
  },
  computed: {
    uuid () {
      return Math.random().toString().split('.')[1]
    }
  },
  methods: {
    copyToClipboard () {
      const el = document.getElementById(this.uuid)
      el.select()
      document.execCommand('copy')
      this.copyLinkText = this.copiedToClipbaordText
      window.setTimeout(() => {
        this.copyLinkText = this.hint
      }, 4000)
    }
  }
}
</script>



// WEBPACK FOOTER //
// CopyTextField.vue?0641c26d